// Function to validate email format
export const validateEmail = (email) => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email) ? null : 'Please enter a valid email address.';
};

// Function to validate password length
export const validatePassword = (password) => {
    return password.length >= 6 ? null : 'Password should be at least 6 characters long.';
};
